import apiClient from '@/plugins/apiClient'
let basePath = "cms/categories";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: {},
          errors: null,
          message: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
     },
     mutations:{
        error(state, err) {
            state.message = err.response.data.message
            state.errors = err.response.data.errors
        },
        setList(state, resp) {
            state.list = resp.data;
        },
        setMeta(state, resp){
          state.meta = resp.meta
        },
        setSingle(state, resp){
          state.single = resp.data
        },
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    var params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'/search?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getFullList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/full-list').then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createCategory({commit}, category){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/create', category).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, id){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/'+id).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit}, category){
               return new Promise((resolve, reject) => {
                    apiClient.patch(basePath+'/'+category.id+'/update', category).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          rebuildSingle({commit}, category){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/'+category.id+'/rebuild').then(resp => {
                         // commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit}, category){
               return new Promise((resolve, reject) => {
                    apiClient.delete(basePath+'/'+category.id+'/delete').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          rebuildCategories({commit}){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/rebuild').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          checkNewCategories({commit}){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/recheck').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          removeErrors({state}){
               state.errors = null;
               state.message = null;
          },
          setMeta({commit}, data){
               commit('setMeta',{meta:data});
               // commit('success', true);
          }
     },
}